import api from './api';

export interface ClientSummary {
  client: {
    id: string;
    agency_id: string;
    email: string;
    name: string;
    phone: string | null;
    assigned_agent_id: string | null;
  };
  total_viewed: number;
  total_liked: number;
  total_rejected: number;
  interactions: Array<{
    id: string;
    client_id: string;
    property_id: string;
    type: 'viewed' | 'liked' | 'rejected';
    created_at: string;
  }>;
  preferences: {
    price_min: number | null;
    price_max: number | null;
    bedrooms_min: number | null;
    bathrooms_min: number | null;
    area_min: number | null;
    zones: string[] | null;
  } | null;
}

export const agentApi = {
  listClients: async () => {
    const res = await api.get('/agent/clients');
    return res.data as ClientSummary['client'][];
  },
  getClientSummary: async (clientId: string): Promise<ClientSummary> => {
    const res = await api.get(`/agent/clients/${clientId}/summary`);
    return res.data;
  },
};
